import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';

const env = process.env.NODE_ENV;
const prodConfig = {
    apiKey: "AIzaSyA8mv_5bo1Gs7qxvp3bwIW59hwidRXumNQ",
    authDomain: "ridegoshare-web.firebaseapp.com",
    databaseURL: "https://ridegoshare-web.firebaseio.com",
    projectId: "ridegoshare-web",
};
const devConfig = {
    apiKey: "AIzaSyC0jKSNM2MJlSIX0GoPyXa8BIHtyw0lTJ0",
    authDomain: "ridegoshare-web-dev.firebaseapp.com",
    databaseURL: "https://ridegoshare-web-dev.firebaseio.com",
    projectId: "ridegoshare-web-dev"
};
const paConfig = {
    apiKey: "AIzaSyA9DzgiCB3xMTH29i24DiaEhacf1xiG7RE",
    authDomain: "ridegoshare-web-pa-42f47.firebaseapp.com",
    databaseURL: "https://ridegoshare-web-pa-42f47.firebaseio.com",
    projectId: "ridegoshare-web-pa-42f47"
};

if (env !== 'production') {
    console.log(env);
}

firebase.initializeApp((() => {
    switch (env) {
    case 'production':
        return prodConfig;
    case 'pa':
        return paConfig;
    default:
        return devConfig;
    }
})());

export default firebase;

export const signInAnonymously = firebase.auth().signInAnonymously();
